<template>
  <div class="content">
    <div class="cards-grid" v-if="prompts.length">
      <PromptCard
        v-for="prompt in prompts"
        :key="prompt.id"
        :prompt="prompt"
        @select-prompt="$emit('select-prompt', prompt)"
      />
      <BbBtn v-if="showMoreButton" size="small" type="quinary" @click="$emit('open-more')"
        >{{ t('assist.moreCards') }}
      </BbBtn>
    </div>
    <div v-else>
      <BbBtn v-if="showMoreButton" size="small" type="quinary" @click="$emit('open-more')"
        >{{ t('assist.moreCards') }}
      </BbBtn>
      <TextBody v-else i18n-key="common.noDataText" tag="span" />
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';

import PromptCard from '~/components/conversation/quickPrompting/PromptCard.vue';
import TextBody from '~/components/common/TextBody.vue';

export default {
  name: 'PromptCardsList',
  components: { TextBody, PromptCard },
  props: {
    prompts: {
      type: Array,
      default: () => [],
    },
    showMoreButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select-prompt', 'open-more'],
  setup() {
    const { t } = useI18n();

    return { t };
  },
};
</script>

<style scoped lang="scss">
.content {
  padding: $bb-spacing-4;
}

.cards-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: $bb-spacing-4;
  align-content: start;

  button {
    margin: auto;

    :deep(.v-btn__content) {
      font-size: 15px;
      color: $bb-primary-3;
      font-weight: 500;
    }
  }
}

@media (max-width: 768px) {
  .cards-grid {
    padding: $bb-spacing-4;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: $bb-spacing-3;
  }
}

@media (max-width: 480px) {
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
</style>
